module.exports = __webpack_public_path__ + "static/media/ndmi3.4564388f.png";